/**   
 * 统一权限接口统一管理
 */
import { axiosPost, axiosPostFormData } from './http';

const prexfix = global.$config.api.apiUrl;
const prexfix2 = global.$config.api.OA_url;
// const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk'
// const prexfix = 'http://biaozhunhua.zjht100.com'

// 根据组织部门id获取部门下的人员信息接口
export const findPerUserByOrganizationId = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/permissions-api/permissions/perUser/findPerUserByOrganizationId `, params)
};

// 获取组织树接口
export const findOrganizationTree = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  } 
  return axiosPost(`/permissions-api/permissions/perOrganization/findOrganizationTree`, params)
};

// 修改密码接口
export const updateUserPasswd = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/permissions-api/permissions/api/per/updateUserPasswd`, params)
};

// 获取权限接口
export const ssoPermission = (data) => {
    const params = {
      baseUrl: prexfix,
      data: data
    }
    return axiosPost(`/permissions-api/permissions/api/per/ssoPermission`, params)
  };

  // 获取权限接口
export const findRolePage = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/permissions-api/permissions/perRole/findPage`, params)
};
  // 获取权限接口
  export const oAaddNews = (data) => {
    // console.log(data)
    // let pUrl = ""
    // for(let k in data){
    //   let a = k+"="+data[k]
    //   if(pUrl==""){
    //     pUrl=a
    //   }else{
    //     pUrl=pUrl+"&"+a
    //   }
      
    // }
    // const params = {
    //   baseUrl: prexfix2,
    //   data: data
    // }
    return axiosPostFormData(`${prexfix2}/sys-news/sysNewsRestService/addNews`, data)
  };

let permissionsApi = {
    findPerUserByOrganizationId,
    findOrganizationTree,
    updateUserPasswd,
    ssoPermission,
    findRolePage,
    oAaddNews
 };
 
 export default permissionsApi;